// React
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Containers Injections
import { OfficesInjection } from '../../containers/officesInjection';

// View
import { OfficeListView } from './view';

export const Offices = () => {
  const { getOffices, deleteOffices, offices, success } = OfficesInjection();

  const history = useHistory();
  const { push } = useHistory();

  const handleDeleteOffice = (id) => {
    deleteOffices(id);
  };

  const handleEditOffice = (item) => {
    history.push(`/escritorios/edit/${item.id}`);
  };

  const handleButton = (route) => {
    history.push(route);
  };

  useEffect(() => {
    getOffices();
  }, [success]);

  return (
    <OfficeListView
      offices={offices}
      handleButton={handleButton}
      handleEditOffice={handleEditOffice}
      handleDeleteOffice={handleDeleteOffice}
      handleNewOffice={() => push('/escritorios/novo')}
    />
  );
};
